export default function TwitterIcon() {
  return (
    <svg className="h-6 fill-current" viewBox="0 0 25 25">
      <path d="M12.5 0a12.5 12.5 0 11-.01 25.01A12.5 12.5 0 0112.5 0zm-2.29 19.1h.06a8.56 8.56 0 008.52-8.52v-.06-.39c.58-.43 1.1-.96 1.5-1.56-.55.24-1.14.4-1.73.47.63-.37 1.1-.97 1.32-1.66-.6.35-1.24.6-1.91.73a3.02 3.02 0 00-5.13 2.75A8.55 8.55 0 016.62 7.7a3.03 3.03 0 00.94 4.01 2.96 2.96 0 01-1.36-.37v.04a3.03 3.03 0 002.42 2.95 3.04 3.04 0 01-1.36.05 3.02 3.02 0 002.8 2.1 6.06 6.06 0 01-4.45 1.24 8.4 8.4 0 004.6 1.36" />
    </svg>
  );
}
